exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".signature-board{width:300px;height:150px;display:flex;justify-content:center;align-items:center;font-size:30px;background-color:#fff;color:gray;border-radius:6px}.signature-board:hover{cursor:pointer}.custom-signature-pad .change-type{width:300px;display:flex;justify-content:center;align-items:center;padding:7px}.custom-signature-pad .change-type button{border:none;border:none;color:#fff;background-color:#a4bf43;padding:7px 30px;border-radius:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/reusableComponents/CustomSignaturePad/customSignaturePad.scss
// module id = 1721
// module chunks = 0